module.exports = __webpack_public_path__ + "static/media/35.5c5fb599.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/35.png
// module id = 539
// module chunks = 0